import { useSelector } from "react-redux";
import { selectUserData } from "../../../../../features/userSlice";
import { Stack } from "@mui/system";
import { Autocomplete, Button, InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import {
  setOpenModalType,
  setPage,
  setSelectedEntityType,
} from "../../../../../features/metaEntitiesSlice";
import { useDispatch } from "react-redux";
import CreateCollectionMethodsModal from "../CollectionMethodsModal/CreateCollectionMethodsModal";
import { useSearchParams } from "react-router-dom";
import store from "../../../../../store";
import { useEffect } from "react";
import { CheckPermissions } from "../../../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";

const CollectionMethodsFilterCard = () => {
  const dispatch = useDispatch();
  const { selectedEntityType, metaEntityList, openModalType } = useSelector(
    (state: any) => state?.metaEntity
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const MetaFilterTypeNames = metaEntityList?.map(
    (metaFormatType: any) => metaFormatType?.collection_method_name
  );

  const response = useSelector(selectUserData);
  const hasCreateCollectionMethodsPermission = CheckPermissions(
    response?.data?.products?.admin,
    "meta_entities",
    "create_collection_methods"
  );

  //-- Function to open modal(create / edit)
  const handleModalOpen = (modalType: string) => {
    dispatch(setOpenModalType(modalType));
  };

  //-- Function to close modal(create / edit)
  const handleCloseModal = () => {
    dispatch(setOpenModalType(null));
  };

  useEffect(() => {
    // Update selectedTemplate when searchParams change (e.g., on back/forward navigation)
    store.dispatch(setSelectedEntityType(searchParams.get("search")));
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Stack
        flexDirection={"row"}
        justifyContent={"start"}
        gap={4}
        sx={{ paddingBlock: "16px" }}
      >
        <Autocomplete
          sx={{ width: "350px" }}
          data-tracker="233"
          options={MetaFilterTypeNames ? MetaFilterTypeNames : []}
          value={selectedEntityType}
          onChange={(_, newValue: any) => {
            dispatch(setSelectedEntityType(newValue));
            // Reset page to 0 when searching
            store.dispatch(setPage(0));
            setSearchParams((prevParams) => {
              const updatedParams = Object.fromEntries(prevParams); // Preserve previous params
              if (newValue) {
                updatedParams.search = newValue; // Set new value
              } else {
                delete updatedParams.search; // Remove from URL if cleared
              }
              // Also update page param in URL to reflect reset
              updatedParams.page = "0";
              return updatedParams;
            });
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Collection Methods"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ marginLeft: "10px" }} />
                  </InputAdornment>
                ),
              }}
              color="secondary"
            />
          )}
          size="small"
        />
        <Stack
          flexDirection={"row"}
          justifyContent={"end"}
          sx={{ width: "100%" }}
        >
          {hasCreateCollectionMethodsPermission ? (
            <Button
              variant="contained"
              color="secondary"
              sx={{ whiteSpace: "nowrap" }}
              onClick={() => handleModalOpen("create")}
              data-tracker="236"
            >
              Create Collection Methods <AddIcon sx={{ ml: 1 }} />
            </Button>
          ) : (
            <>
              <Button variant="contained" disabled>
                Create Collection Methods <AddIcon sx={{ ml: 1 }} />
              </Button>
            </>
          )}
        </Stack>
      </Stack>
      {openModalType === "create" && (
        <CreateCollectionMethodsModal
          open={true}
          handleClose={handleCloseModal}
        />
      )}
    </>
  );
};

export default CollectionMethodsFilterCard;
